<template>
    <modal v-model="visible" :title="'Foto do paciente'">
        <loading :active.sync="overlay" :is-full-page="false"></loading>
        <div class="modal-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="area">
                        <video autoplay="true" id="webCamera"></video>
                        <input  type="hidden" id="base_img" name="base_img"/>
                        <button type="button" @click="takeSnapShot(person.id)">Tirar foto e salvar</button>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="w-100">
            <btn type="primary" @click="visible = false">Cancelar</btn>
        </div>
    </modal>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "WebcamPhoto",
        components: { Loading },
        props: {
            person: { Object, required: true },
            url:{ String, required: true}
        },
        watch: {
            visible: function (visible) {
                if(!visible){
                    this.stopCamera()
                }
            }
        },
        data() {
            return {
                overlay: false,
                visible: false,
                optionsToast: { timeout: 6000, position: 'topCenter' }
            }
        },
        methods: {
            loadCamera() {
                let self = this;
                self.visible = true;
                //Captura elemento de vídeo
                this.$nextTick(function () {
                    let video = document.querySelector("#webCamera");
                    //As opções abaixo são necessárias para o funcionamento correto no iOS
                    video.setAttribute('autoplay', '');
                    video.setAttribute('muted', '');
                    video.setAttribute('playsinline', '');
                    //Verifica se o navegador pode capturar mídia
                    if (navigator.mediaDevices.getUserMedia) {
                        navigator.mediaDevices.getUserMedia({audio: false, video: {facingMode: 'user'}})
                            .then(function (stream) {
                                //Definir o elemento vídeo a carregar o capturado pela webcam
                                video.srcObject = stream;
                            })
                            .catch(function (error) {
                                self.$toast.error('Oooopps... Desculpe, tivemos algum problema...', 'Erro', this.optionsToast);
                                console.log(error.response)
                            });
                    }
                })
            },

            takeSnapShot(person_id) {
                //Captura elemento de vídeo
                let video = document.querySelector("#webCamera");

                //Criando um canvas que vai guardar a imagem temporariamente
                let canvas = document.createElement('canvas');
                canvas.width = 200;                // canvas.width = video.videoWidth;
                canvas.height = 200;               // canvas.height = video.videoHeight;

                let ctx = canvas.getContext('2d');

                //Desenhando e convertendo as dimensões
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                //Criando o JPG
                let dataURI = canvas.toDataURL('image/jpeg'); //O resultado é um BASE64 de uma imagem.
                document.querySelector("#base_img").value = dataURI;

                this.sendSnapShot(dataURI, person_id); //Gerar Imagem e Salvar Caminho no Banco
            },

            /**
             * Envia imagem para o servidor
             * @param base64
             * @param person_id
             */
            sendSnapShot(base64, person_id) {
                this.overlay = true;
                axios.post(this.url, {base_img: base64, person_id: person_id})
                    .then(response => {
                        if (response.data.type == 'success') {
                            //Alterar imagem
                            let d = new Date();
                            document.querySelector(".imagemConvertida").setAttribute("src", response.data.img + "?" + d.getTime());
                            this.overlay = false;
                            this.visible = false;
                            this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                        } else if (response.data.type == 'warning') {
                            this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                        } else {
                            this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                        }
                    }).catch(error => {
                    console.log(error.response);
                    if (error.response.status === 401 || error.response.status === 419) {
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                });
            },

            /**
             * Desliga a webcam
             * @param e
             * @returns {boolean}
             */
            stopCamera() {
                let video = document.querySelector("#webCamera");
                if (video.srcObject) {
                    let stream = video.srcObject;
                    let tracks = stream.getTracks();
                    for (let i = 0; i < tracks.length; i++) {
                        let track = tracks[i];
                        track.stop();
                    }
                    video.srcObject = null;
                } else {
                    return false;
                }
                return true;
            },
        }
    }
</script>

<style scoped>
    .modal-title{
        color: black !important;
    }
    .area{
        margin: 10px auto;
        box-shadow: 0 10px 100px #ccc;
        padding: 20px;
        box-sizing: border-box;
        max-width: 500px;
    }
    .area video{
        width: 100%;
        height: auto;
        background-color: whitesmoke;
    }
    .area textarea{
        width: 100%;
        margin-top: 10px;
        height: 80px;
        box-sizing: border-box;
    }
    .area button{
        -webkit-appearance: none;
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        text-align: center;
        background-color: #068c84;
        color: white;
        text-transform: uppercase;
        border: 1px solid white;
        box-shadow: 0 1px 5px #666;
    }
    .area button:focus{
        outline: none;
        background-color: #0989b0;
    }
    .area img{
        max-width: 100%;
        height: auto;
    }
    .area .caminho-imagem{
        padding: 5px 10px;
        border-radius: 3px;
        background-color: #068c84;
        text-align: center;
    }
    .area .caminho-imagem a{
        color: white;
        text-decoration: none;
    }
    .area .caminho-imagem a:hover{
        color: yellow;
    }
</style>
